<div class="projects-summary">
  <div class="header">Projects Summary</div>
  <div class="flex justify-between projects-summary-item">
    <div class="flex-1">Project Type</div>
    <div class="flex-1 text-right">Avg. Cost</div>
  </div>
  @for (projectTypeSummary of projectTypeSummeries; track projectTypeSummary.id) {
    <div class="flex justify-between projects-summary-item">
      <div>({{ projectTypeSummary.count }}) {{ projectTypeSummary.name }}</div>
      <div>{{ projectTypeSummary.averageCost | currency }}</div>
    </div>
  }
</div>
